/* eslint-disable */
import 'jquery.cookie';
import wildcardDomain from "@/js/common/Domain/Service/wildcardDomain";

var customerEmail = $.cookie('customerEmail');

var AccountModel = Backbone.Epoxy.Model.extend({
	defaults: {
		profileRequestInProgress: false,
		authorized: false,
		customerEmail: customerEmail ? customerEmail : '',
		name: false,
		profileDataReceived: 0,
        customerUuid: null,
	},
	computeds: {
		email: {
			deps: ["customerEmail"],
			get: function (value) {
				return value;
			},
			set: function (value) {
				$.cookie('customerEmail', value, {path: '/', expires: 999, domain: wildcardDomain()});
				return {
					customerEmail: value
				}
			}
		}
	}
});

let accoutModel = new AccountModel();

export default accoutModel;
